import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BuildingModelAssetBundle } from '../models/building-model-assets.model';

/**
 * Resolves which static or API-backed URLs load the GLB and JSON for a building.
 * Resolved via `HttpBuildingModelAssetsService` (`ApiService` + `ConfigurationManagerService.settings.BaseURL` when live).
 */
@Injectable()
export abstract class BuildingModelAssetsService {
  /**
   * @param resolutionKey id from the active facility/building context (perimeter, facility, etc.)
   */
  abstract getAssetBundle(resolutionKey?: string | null): Observable<BuildingModelAssetBundle>;
}
